//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ADFSService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    post(code: string, clientId: string, redirectUri: string): Observable<any> {
        let url_ = this.baseUrl + "/api/adfs/Auth?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (redirectUri === undefined || redirectUri === null)
            throw new Error("The parameter 'redirectUri' must be defined and cannot be null.");
        else
            url_ += "redirectUri=" + encodeURIComponent("" + redirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    pullConfiguration(eventCode: string): Observable<WrappedResponseOfEventConfigurationDTO> {
        let url_ = this.baseUrl + "/api/config/pullConfiguration?";
        if (eventCode === undefined || eventCode === null)
            throw new Error("The parameter 'eventCode' must be defined and cannot be null.");
        else
            url_ += "eventCode=" + encodeURIComponent("" + eventCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPullConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPullConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfEventConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfEventConfigurationDTO>;
        }));
    }

    protected processPullConfiguration(response: HttpResponseBase): Observable<WrappedResponseOfEventConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfEventConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfEventConfigurationDTO>(null as any);
    }

    /**
     * @return OK
     */
    getTimeZoneOffset(): Observable<number> {
        let url_ = this.baseUrl + "/api/config/timeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeZoneOffset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeZoneOffset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTimeZoneOffset(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): Observable<WrappedResponseOfEventConfigurationDTO> {
        let url_ = this.baseUrl + "/api/Config/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfEventConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfEventConfigurationDTO>;
        }));
    }

    protected processFetch(response: HttpResponseBase): Observable<WrappedResponseOfEventConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfEventConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfEventConfigurationDTO>(null as any);
    }

    /**
     * @return OK
     */
    list(query: GenericPagedFilter): Observable<WrappedResponseOfPagedListOfEventConfigurationDTO> {
        let url_ = this.baseUrl + "/api/Config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfPagedListOfEventConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfPagedListOfEventConfigurationDTO>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<WrappedResponseOfPagedListOfEventConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfPagedListOfEventConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfPagedListOfEventConfigurationDTO>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    get(): Observable<any> {
        let url_ = this.baseUrl + "/api/diagnostic/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TicketBookingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    getTicketsByUser(): Observable<WrappedResponseOfListOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/by-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfListOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfListOfTicketBookingDTO>;
        }));
    }

    protected processGetTicketsByUser(response: HttpResponseBase): Observable<WrappedResponseOfListOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfListOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfListOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    getInvitesByUser(input: TicketBookingDTO): Observable<WrappedResponseOfListOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/invites-by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfListOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfListOfTicketBookingDTO>;
        }));
    }

    protected processGetInvitesByUser(response: HttpResponseBase): Observable<WrappedResponseOfListOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfListOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfListOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    saveTemporaryTicket(input: AddTemporaryTicketInDTO): Observable<WrappedResponseOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/temporary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTemporaryTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTemporaryTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingDTO>;
        }));
    }

    protected processSaveTemporaryTicket(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    confirmTemporaryTicket(id: number): Observable<WrappedResponseOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/{id}/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmTemporaryTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTemporaryTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingDTO>;
        }));
    }

    protected processConfirmTemporaryTicket(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    cancelConfirmedTicket(id: number): Observable<WrappedResponseOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelConfirmedTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelConfirmedTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingDTO>;
        }));
    }

    protected processCancelConfirmedTicket(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    update(id: number, input: UpdateTicketInDTO): Observable<WrappedResponseOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingDTO>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingDTO>(null as any);
    }

    /**
     * @return OK
     */
    addTickets(id: number, input: AddTicketInDTO): Observable<WrappedResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/tickets-booking/{id}/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfBoolean>;
        }));
    }

    protected processAddTickets(response: HttpResponseBase): Observable<WrappedResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    export(from: Date, to: Date): Observable<WrappedResponseOfTicketBookingExportDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/export?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingExportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingExportDTO>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingExportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingExportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingExportDTO>(null as any);
    }

    /**
     * @param file Upload file to import
     * @return OK
     */
    import(file: FileParameter): Observable<WrappedResponseOfTicketBookingImportDTO> {
        let url_ = this.baseUrl + "/api/tickets-booking/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingImportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingImportDTO>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingImportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingImportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingImportDTO>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<WrappedResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/TicketBooking/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfBoolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<WrappedResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): Observable<WrappedResponseOfTicketBookingDTO> {
        let url_ = this.baseUrl + "/api/TicketBooking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTicketBookingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTicketBookingDTO>;
        }));
    }

    protected processFetch(response: HttpResponseBase): Observable<WrappedResponseOfTicketBookingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTicketBookingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTicketBookingDTO>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TimeSlotService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    list(query: GenericPagedFilter): Observable<WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO> {
        let url_ = this.baseUrl + "/api/time-slots/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): Observable<WrappedResponseOfTimeSlotAvailabilityDTO> {
        let url_ = this.baseUrl + "/api/TimeSlot/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfTimeSlotAvailabilityDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfTimeSlotAvailabilityDTO>;
        }));
    }

    protected processFetch(response: HttpResponseBase): Observable<WrappedResponseOfTimeSlotAvailabilityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfTimeSlotAvailabilityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfTimeSlotAvailabilityDTO>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44380";
    }

    /**
     * @return OK
     */
    me(): Observable<WrappedResponseOfUserDTO> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WrappedResponseOfUserDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WrappedResponseOfUserDTO>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<WrappedResponseOfUserDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WrappedResponseOfUserDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WrappedResponseOfUserDTO>(null as any);
    }
}

export class WrappedResponseOfEventConfigurationDTO implements IWrappedResponseOfEventConfigurationDTO {
    metadata?: Metadata | null;
    data?: EventConfigurationDTO | null;
    status?: WrappedResponseOfEventConfigurationDTOStatus | null;

    constructor(data?: IWrappedResponseOfEventConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? EventConfigurationDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfEventConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfEventConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfEventConfigurationDTO {
    metadata?: Metadata | null;
    data?: EventConfigurationDTO | null;
    status?: WrappedResponseOfEventConfigurationDTOStatus | null;
}

export class Metadata implements IMetadata {
    uiMessages?: UiMessage[] | null;

    constructor(data?: IMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uiMessages"])) {
                this.uiMessages = [] as any;
                for (let item of _data["uiMessages"])
                    this.uiMessages!.push(UiMessage.fromJS(item));
            }
            else {
                this.uiMessages = <any>null;
            }
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uiMessages)) {
            data["uiMessages"] = [];
            for (let item of this.uiMessages)
                data["uiMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMetadata {
    uiMessages?: UiMessage[] | null;
}

export class EventConfigurationDTO implements IEventConfigurationDTO {
    idEvent?: number | null;
    eventCode?: string | null;
    eventDescription?: string | null;
    eventStartDate?: Date | null;
    eventEndDate?: Date | null;
    userTicketThreshold?: number | null;
    userInvitesThreshold?: number | null;
    timeZoneId?: string | null;
    id?: number | null;

    constructor(data?: IEventConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idEvent = _data["idEvent"] !== undefined ? _data["idEvent"] : <any>null;
            this.eventCode = _data["eventCode"] !== undefined ? _data["eventCode"] : <any>null;
            this.eventDescription = _data["eventDescription"] !== undefined ? _data["eventDescription"] : <any>null;
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : <any>null;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : <any>null;
            this.userTicketThreshold = _data["userTicketThreshold"] !== undefined ? _data["userTicketThreshold"] : <any>null;
            this.userInvitesThreshold = _data["userInvitesThreshold"] !== undefined ? _data["userInvitesThreshold"] : <any>null;
            this.timeZoneId = _data["timeZoneId"] !== undefined ? _data["timeZoneId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): EventConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EventConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEvent"] = this.idEvent !== undefined ? this.idEvent : <any>null;
        data["eventCode"] = this.eventCode !== undefined ? this.eventCode : <any>null;
        data["eventDescription"] = this.eventDescription !== undefined ? this.eventDescription : <any>null;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : <any>null;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : <any>null;
        data["userTicketThreshold"] = this.userTicketThreshold !== undefined ? this.userTicketThreshold : <any>null;
        data["userInvitesThreshold"] = this.userInvitesThreshold !== undefined ? this.userInvitesThreshold : <any>null;
        data["timeZoneId"] = this.timeZoneId !== undefined ? this.timeZoneId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IEventConfigurationDTO {
    idEvent?: number | null;
    eventCode?: string | null;
    eventDescription?: string | null;
    eventStartDate?: Date | null;
    eventEndDate?: Date | null;
    userTicketThreshold?: number | null;
    userInvitesThreshold?: number | null;
    timeZoneId?: string | null;
    id?: number | null;
}

export class UiMessage implements IUiMessage {
    code?: string | null;
    title?: string | null;
    message?: string | null;
    type?: UiMessageType | null;
    fieldId?: string | null;
    target?: UiMessageTarget | null;
    cultureName?: string | null;

    constructor(data?: IUiMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.fieldId = _data["fieldId"] !== undefined ? _data["fieldId"] : <any>null;
            this.target = _data["target"] !== undefined ? _data["target"] : <any>null;
            this.cultureName = _data["cultureName"] !== undefined ? _data["cultureName"] : <any>null;
        }
    }

    static fromJS(data: any): UiMessage {
        data = typeof data === 'object' ? data : {};
        let result = new UiMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["fieldId"] = this.fieldId !== undefined ? this.fieldId : <any>null;
        data["target"] = this.target !== undefined ? this.target : <any>null;
        data["cultureName"] = this.cultureName !== undefined ? this.cultureName : <any>null;
        return data;
    }
}

export interface IUiMessage {
    code?: string | null;
    title?: string | null;
    message?: string | null;
    type?: UiMessageType | null;
    fieldId?: string | null;
    target?: UiMessageTarget | null;
    cultureName?: string | null;
}

export class GenericPagedFilter implements IGenericPagedFilter {
    pageNumber?: number | null;
    pageSize?: number | null;
    filter?: Filter[] | null;
    orderBy?: OrderBy[] | null;

    constructor(data?: IGenericPagedFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(Filter.fromJS(item));
            }
            else {
                this.filter = <any>null;
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            else {
                this.orderBy = <any>null;
            }
        }
    }

    static fromJS(data: any): GenericPagedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GenericPagedFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGenericPagedFilter {
    pageNumber?: number | null;
    pageSize?: number | null;
    filter?: Filter[] | null;
    orderBy?: OrderBy[] | null;
}

export class Filter implements IFilter {
    name?: string | null;
    comparator?: FilterComparator | null;
    value?: string | null;
    conjunction?: FilterConjunction | null;
    inner?: Filter[] | null;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.comparator = _data["comparator"] !== undefined ? _data["comparator"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.conjunction = _data["conjunction"] !== undefined ? _data["conjunction"] : <any>null;
            if (Array.isArray(_data["inner"])) {
                this.inner = [] as any;
                for (let item of _data["inner"])
                    this.inner!.push(Filter.fromJS(item));
            }
            else {
                this.inner = <any>null;
            }
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["comparator"] = this.comparator !== undefined ? this.comparator : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["conjunction"] = this.conjunction !== undefined ? this.conjunction : <any>null;
        if (Array.isArray(this.inner)) {
            data["inner"] = [];
            for (let item of this.inner)
                data["inner"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilter {
    name?: string | null;
    comparator?: FilterComparator | null;
    value?: string | null;
    conjunction?: FilterConjunction | null;
    inner?: Filter[] | null;
}

export class OrderBy implements IOrderBy {
    name?: string | null;
    direction?: OrderByDirection | null;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        return data;
    }
}

export interface IOrderBy {
    name?: string | null;
    direction?: OrderByDirection | null;
}

export class WrappedResponseOfPagedListOfEventConfigurationDTO implements IWrappedResponseOfPagedListOfEventConfigurationDTO {
    metadata?: Metadata | null;
    data?: PagedListOfEventConfigurationDTO | null;
    status?: WrappedResponseOfPagedListOfEventConfigurationDTOStatus | null;

    constructor(data?: IWrappedResponseOfPagedListOfEventConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? PagedListOfEventConfigurationDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfPagedListOfEventConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfPagedListOfEventConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfPagedListOfEventConfigurationDTO {
    metadata?: Metadata | null;
    data?: PagedListOfEventConfigurationDTO | null;
    status?: WrappedResponseOfPagedListOfEventConfigurationDTOStatus | null;
}

export class PagedListOfEventConfigurationDTO implements IPagedListOfEventConfigurationDTO {
    readonly items?: EventConfigurationDTO[] | null;
    readonly count?: number | null;
    readonly pageIndex?: number | null;
    readonly pageSize?: number | null;
    readonly totalCount?: number | null;
    readonly totalPages?: number | null;
    readonly hasPreviousPage?: boolean | null;
    readonly hasNextPage?: boolean | null;

    constructor(data?: IPagedListOfEventConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(EventConfigurationDTO.fromJS(item));
            }
            else {
                (<any>this).items = <any>null;
            }
            (<any>this).count = _data["count"] !== undefined ? _data["count"] : <any>null;
            (<any>this).pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : <any>null;
            (<any>this).pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            (<any>this).totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            (<any>this).totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            (<any>this).hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            (<any>this).hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
        }
    }

    static fromJS(data: any): PagedListOfEventConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfEventConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        return data;
    }
}

export interface IPagedListOfEventConfigurationDTO {
    items?: EventConfigurationDTO[] | null;
    count?: number | null;
    pageIndex?: number | null;
    pageSize?: number | null;
    totalCount?: number | null;
    totalPages?: number | null;
    hasPreviousPage?: boolean | null;
    hasNextPage?: boolean | null;
}

export class WrappedResponseOfListOfTicketBookingDTO implements IWrappedResponseOfListOfTicketBookingDTO {
    metadata?: Metadata | null;
    data?: TicketBookingDTO[] | null;
    status?: WrappedResponseOfListOfTicketBookingDTOStatus | null;

    constructor(data?: IWrappedResponseOfListOfTicketBookingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TicketBookingDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfListOfTicketBookingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfListOfTicketBookingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfListOfTicketBookingDTO {
    metadata?: Metadata | null;
    data?: TicketBookingDTO[] | null;
    status?: WrappedResponseOfListOfTicketBookingDTOStatus | null;
}

export class TicketBookingDTO implements ITicketBookingDTO {
    timeSlotId?: number | null;
    userCID?: string | null;
    userDisplayName?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    userEmail?: string | null;
    ticketFirstName?: string | null;
    ticketLastName?: string | null;
    ticketEmail?: string | null;
    disclaimer?: boolean | null;
    status?: TicketBookingDTOStatus | null;
    tmpExpire?: Date | null;
    timeSlotValue?: Date | null;
    cutOffDate?: Date | null;
    employeeReserved?: boolean | null;
    timeSlotAttendeeLeft?: number | null;
    isVip?: boolean | null;
    isMinor?: boolean | null;
    parentId?: number | null;
    timeSlotCategoryId?: number | null;
    timeSlotCategoryDescription?: string | null;
    termsAccepted?: boolean | null;
    forceTermsAcceptance?: boolean | null;
    openInvite?: boolean | null;
    externalInvite?: boolean | null;
    id?: number | null;

    constructor(data?: ITicketBookingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSlotId = _data["timeSlotId"] !== undefined ? _data["timeSlotId"] : <any>null;
            this.userCID = _data["userCID"] !== undefined ? _data["userCID"] : <any>null;
            this.userDisplayName = _data["userDisplayName"] !== undefined ? _data["userDisplayName"] : <any>null;
            this.userFirstName = _data["userFirstName"] !== undefined ? _data["userFirstName"] : <any>null;
            this.userLastName = _data["userLastName"] !== undefined ? _data["userLastName"] : <any>null;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : <any>null;
            this.ticketFirstName = _data["ticketFirstName"] !== undefined ? _data["ticketFirstName"] : <any>null;
            this.ticketLastName = _data["ticketLastName"] !== undefined ? _data["ticketLastName"] : <any>null;
            this.ticketEmail = _data["ticketEmail"] !== undefined ? _data["ticketEmail"] : <any>null;
            this.disclaimer = _data["disclaimer"] !== undefined ? _data["disclaimer"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.tmpExpire = _data["tmpExpire"] ? new Date(_data["tmpExpire"].toString()) : <any>null;
            this.timeSlotValue = _data["timeSlotValue"] ? new Date(_data["timeSlotValue"].toString()) : <any>null;
            this.cutOffDate = _data["cutOffDate"] ? new Date(_data["cutOffDate"].toString()) : <any>null;
            this.employeeReserved = _data["employeeReserved"] !== undefined ? _data["employeeReserved"] : <any>null;
            this.timeSlotAttendeeLeft = _data["timeSlotAttendeeLeft"] !== undefined ? _data["timeSlotAttendeeLeft"] : <any>null;
            this.isVip = _data["isVip"] !== undefined ? _data["isVip"] : <any>null;
            this.isMinor = _data["isMinor"] !== undefined ? _data["isMinor"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.timeSlotCategoryId = _data["timeSlotCategoryId"] !== undefined ? _data["timeSlotCategoryId"] : <any>null;
            this.timeSlotCategoryDescription = _data["timeSlotCategoryDescription"] !== undefined ? _data["timeSlotCategoryDescription"] : <any>null;
            this.termsAccepted = _data["termsAccepted"] !== undefined ? _data["termsAccepted"] : <any>null;
            this.forceTermsAcceptance = _data["forceTermsAcceptance"] !== undefined ? _data["forceTermsAcceptance"] : <any>null;
            this.openInvite = _data["openInvite"] !== undefined ? _data["openInvite"] : <any>null;
            this.externalInvite = _data["externalInvite"] !== undefined ? _data["externalInvite"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): TicketBookingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketBookingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSlotId"] = this.timeSlotId !== undefined ? this.timeSlotId : <any>null;
        data["userCID"] = this.userCID !== undefined ? this.userCID : <any>null;
        data["userDisplayName"] = this.userDisplayName !== undefined ? this.userDisplayName : <any>null;
        data["userFirstName"] = this.userFirstName !== undefined ? this.userFirstName : <any>null;
        data["userLastName"] = this.userLastName !== undefined ? this.userLastName : <any>null;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : <any>null;
        data["ticketFirstName"] = this.ticketFirstName !== undefined ? this.ticketFirstName : <any>null;
        data["ticketLastName"] = this.ticketLastName !== undefined ? this.ticketLastName : <any>null;
        data["ticketEmail"] = this.ticketEmail !== undefined ? this.ticketEmail : <any>null;
        data["disclaimer"] = this.disclaimer !== undefined ? this.disclaimer : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["tmpExpire"] = this.tmpExpire ? this.tmpExpire.toISOString() : <any>null;
        data["timeSlotValue"] = this.timeSlotValue ? this.timeSlotValue.toISOString() : <any>null;
        data["cutOffDate"] = this.cutOffDate ? this.cutOffDate.toISOString() : <any>null;
        data["employeeReserved"] = this.employeeReserved !== undefined ? this.employeeReserved : <any>null;
        data["timeSlotAttendeeLeft"] = this.timeSlotAttendeeLeft !== undefined ? this.timeSlotAttendeeLeft : <any>null;
        data["isVip"] = this.isVip !== undefined ? this.isVip : <any>null;
        data["isMinor"] = this.isMinor !== undefined ? this.isMinor : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["timeSlotCategoryId"] = this.timeSlotCategoryId !== undefined ? this.timeSlotCategoryId : <any>null;
        data["timeSlotCategoryDescription"] = this.timeSlotCategoryDescription !== undefined ? this.timeSlotCategoryDescription : <any>null;
        data["termsAccepted"] = this.termsAccepted !== undefined ? this.termsAccepted : <any>null;
        data["forceTermsAcceptance"] = this.forceTermsAcceptance !== undefined ? this.forceTermsAcceptance : <any>null;
        data["openInvite"] = this.openInvite !== undefined ? this.openInvite : <any>null;
        data["externalInvite"] = this.externalInvite !== undefined ? this.externalInvite : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ITicketBookingDTO {
    timeSlotId?: number | null;
    userCID?: string | null;
    userDisplayName?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    userEmail?: string | null;
    ticketFirstName?: string | null;
    ticketLastName?: string | null;
    ticketEmail?: string | null;
    disclaimer?: boolean | null;
    status?: TicketBookingDTOStatus | null;
    tmpExpire?: Date | null;
    timeSlotValue?: Date | null;
    cutOffDate?: Date | null;
    employeeReserved?: boolean | null;
    timeSlotAttendeeLeft?: number | null;
    isVip?: boolean | null;
    isMinor?: boolean | null;
    parentId?: number | null;
    timeSlotCategoryId?: number | null;
    timeSlotCategoryDescription?: string | null;
    termsAccepted?: boolean | null;
    forceTermsAcceptance?: boolean | null;
    openInvite?: boolean | null;
    externalInvite?: boolean | null;
    id?: number | null;
}

export class AddTemporaryTicketInDTO implements IAddTemporaryTicketInDTO {
    timeSlotId!: number;

    constructor(data?: IAddTemporaryTicketInDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSlotId = _data["timeSlotId"] !== undefined ? _data["timeSlotId"] : <any>null;
        }
    }

    static fromJS(data: any): AddTemporaryTicketInDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddTemporaryTicketInDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSlotId"] = this.timeSlotId !== undefined ? this.timeSlotId : <any>null;
        return data;
    }
}

export interface IAddTemporaryTicketInDTO {
    timeSlotId: number;
}

export class WrappedResponseOfTicketBookingDTO implements IWrappedResponseOfTicketBookingDTO {
    metadata?: Metadata | null;
    data?: TicketBookingDTO | null;
    status?: WrappedResponseOfTicketBookingDTOStatus | null;

    constructor(data?: IWrappedResponseOfTicketBookingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? TicketBookingDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfTicketBookingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfTicketBookingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfTicketBookingDTO {
    metadata?: Metadata | null;
    data?: TicketBookingDTO | null;
    status?: WrappedResponseOfTicketBookingDTOStatus | null;
}

export class UpdateTicketInDTO implements IUpdateTicketInDTO {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    disclaimer?: boolean | null;
    isVip?: boolean | null;
    termsAccepted?: boolean | null;
    isExternalInvite?: boolean | null;
    forceTermsAcceptance?: boolean | null;

    constructor(data?: IUpdateTicketInDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.disclaimer = _data["disclaimer"] !== undefined ? _data["disclaimer"] : <any>null;
            this.isVip = _data["isVip"] !== undefined ? _data["isVip"] : <any>null;
            this.termsAccepted = _data["termsAccepted"] !== undefined ? _data["termsAccepted"] : <any>null;
            this.isExternalInvite = _data["isExternalInvite"] !== undefined ? _data["isExternalInvite"] : <any>null;
            this.forceTermsAcceptance = _data['forceTermsAcceptance'] !== undefined ? _data['forceTermsAcceptance'] : <any>null;
        }
    }

    static fromJS(data: any): UpdateTicketInDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketInDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["disclaimer"] = this.disclaimer !== undefined ? this.disclaimer : <any>null;
        data["isVip"] = this.isVip !== undefined ? this.isVip : <any>null;
        data["termsAccepted"] = this.termsAccepted !== undefined ? this.termsAccepted : <any>null;
        data["isExternalInvite"] = this.isExternalInvite !== undefined ? this.isExternalInvite : <any>null;
        data['forceTermsAcceptance'] = this.forceTermsAcceptance !== undefined ? this.forceTermsAcceptance : <any>null;
        return data;
    }
}

export interface IUpdateTicketInDTO {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    disclaimer?: boolean | null;
    isVip?: boolean | null;
    termsAccepted?: boolean | null;
    isExternalInvite?: boolean | null;
}

export class AddTicketInDTO implements IAddTicketInDTO {
    toAdd?: number | null;
    toAddMinor?: number | null;
    readonly totalToAdd?: number | null;

    constructor(data?: IAddTicketInDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toAdd = _data["toAdd"] !== undefined ? _data["toAdd"] : <any>null;
            this.toAddMinor = _data["toAddMinor"] !== undefined ? _data["toAddMinor"] : <any>null;
            (<any>this).totalToAdd = _data["totalToAdd"] !== undefined ? _data["totalToAdd"] : <any>null;
        }
    }

    static fromJS(data: any): AddTicketInDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddTicketInDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAdd"] = this.toAdd !== undefined ? this.toAdd : <any>null;
        data["toAddMinor"] = this.toAddMinor !== undefined ? this.toAddMinor : <any>null;
        data["totalToAdd"] = this.totalToAdd !== undefined ? this.totalToAdd : <any>null;
        return data;
    }
}

export interface IAddTicketInDTO {
    toAdd?: number | null;
    toAddMinor?: number | null;
    totalToAdd?: number | null;
}

export class WrappedResponseOfBoolean implements IWrappedResponseOfBoolean {
    metadata?: Metadata | null;
    data?: boolean | null;
    status?: WrappedResponseOfBooleanStatus | null;

    constructor(data?: IWrappedResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfBoolean {
    metadata?: Metadata | null;
    data?: boolean | null;
    status?: WrappedResponseOfBooleanStatus | null;
}

export class WrappedResponseOfTicketBookingExportDTO implements IWrappedResponseOfTicketBookingExportDTO {
    metadata?: Metadata | null;
    data?: TicketBookingExportDTO | null;
    status?: WrappedResponseOfTicketBookingExportDTOStatus | null;

    constructor(data?: IWrappedResponseOfTicketBookingExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? TicketBookingExportDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfTicketBookingExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfTicketBookingExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfTicketBookingExportDTO {
    metadata?: Metadata | null;
    data?: TicketBookingExportDTO | null;
    status?: WrappedResponseOfTicketBookingExportDTOStatus | null;
}

export class TicketBookingExportDTO implements ITicketBookingExportDTO {
    fileName?: string | null;
    fileBase64?: string | null;

    constructor(data?: ITicketBookingExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
        }
    }

    static fromJS(data: any): TicketBookingExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketBookingExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        return data;
    }
}

export interface ITicketBookingExportDTO {
    fileName?: string | null;
    fileBase64?: string | null;
}

export class WrappedResponseOfTicketBookingImportDTO implements IWrappedResponseOfTicketBookingImportDTO {
    metadata?: Metadata | null;
    data?: TicketBookingImportDTO | null;
    status?: WrappedResponseOfTicketBookingImportDTOStatus | null;

    constructor(data?: IWrappedResponseOfTicketBookingImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? TicketBookingImportDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfTicketBookingImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfTicketBookingImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfTicketBookingImportDTO {
    metadata?: Metadata | null;
    data?: TicketBookingImportDTO | null;
    status?: WrappedResponseOfTicketBookingImportDTOStatus | null;
}

export class TicketBookingImportDTO implements ITicketBookingImportDTO {
    totalRow?: number | null;
    updatedRow?: number | null;
    errorRow?: number | null;

    constructor(data?: ITicketBookingImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRow = _data["totalRow"] !== undefined ? _data["totalRow"] : <any>null;
            this.updatedRow = _data["updatedRow"] !== undefined ? _data["updatedRow"] : <any>null;
            this.errorRow = _data["errorRow"] !== undefined ? _data["errorRow"] : <any>null;
        }
    }

    static fromJS(data: any): TicketBookingImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketBookingImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRow"] = this.totalRow !== undefined ? this.totalRow : <any>null;
        data["updatedRow"] = this.updatedRow !== undefined ? this.updatedRow : <any>null;
        data["errorRow"] = this.errorRow !== undefined ? this.errorRow : <any>null;
        return data;
    }
}

export interface ITicketBookingImportDTO {
    totalRow?: number | null;
    updatedRow?: number | null;
    errorRow?: number | null;
}

export class WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO implements IWrappedResponseOfPagedListOfTimeSlotAvailabilityDTO {
    metadata?: Metadata | null;
    data?: PagedListOfTimeSlotAvailabilityDTO | null;
    status?: WrappedResponseOfPagedListOfTimeSlotAvailabilityDTOStatus | null;

    constructor(data?: IWrappedResponseOfPagedListOfTimeSlotAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? PagedListOfTimeSlotAvailabilityDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfPagedListOfTimeSlotAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfPagedListOfTimeSlotAvailabilityDTO {
    metadata?: Metadata | null;
    data?: PagedListOfTimeSlotAvailabilityDTO | null;
    status?: WrappedResponseOfPagedListOfTimeSlotAvailabilityDTOStatus | null;
}

export class PagedListOfTimeSlotAvailabilityDTO implements IPagedListOfTimeSlotAvailabilityDTO {
    readonly items?: TimeSlotAvailabilityDTO[] | null;
    readonly count?: number | null;
    readonly pageIndex?: number | null;
    readonly pageSize?: number | null;
    readonly totalCount?: number | null;
    readonly totalPages?: number | null;
    readonly hasPreviousPage?: boolean | null;
    readonly hasNextPage?: boolean | null;

    constructor(data?: IPagedListOfTimeSlotAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(TimeSlotAvailabilityDTO.fromJS(item));
            }
            else {
                (<any>this).items = <any>null;
            }
            (<any>this).count = _data["count"] !== undefined ? _data["count"] : <any>null;
            (<any>this).pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : <any>null;
            (<any>this).pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            (<any>this).totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            (<any>this).totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            (<any>this).hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            (<any>this).hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
        }
    }

    static fromJS(data: any): PagedListOfTimeSlotAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfTimeSlotAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        return data;
    }
}

export interface IPagedListOfTimeSlotAvailabilityDTO {
    items?: TimeSlotAvailabilityDTO[] | null;
    count?: number | null;
    pageIndex?: number | null;
    pageSize?: number | null;
    totalCount?: number | null;
    totalPages?: number | null;
    hasPreviousPage?: boolean | null;
    hasNextPage?: boolean | null;
}

export class TimeSlotAvailabilityDTO implements ITimeSlotAvailabilityDTO {
    timeSlotValue?: Date | null;
    cutOffDate?: Date | null;
    attendeeSoftThreshold?: number | null;
    attendeeHardThreshold?: number | null;
    employeeReserved?: boolean | null;
    booked?: number | null;
    timeSlotCategoryId?: number | null;
    timeSlotCategoryDescription?: string | null;
    forceTermsAcceptance?: boolean | null;
    openInvite?: boolean | null;
    id?: number | null;

    constructor(data?: ITimeSlotAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSlotValue = _data["timeSlotValue"] ? new Date(_data["timeSlotValue"].toString()) : <any>null;
            this.cutOffDate = _data["cutOffDate"] ? new Date(_data["cutOffDate"].toString()) : <any>null;
            this.attendeeSoftThreshold = _data["attendeeSoftThreshold"] !== undefined ? _data["attendeeSoftThreshold"] : <any>null;
            this.attendeeHardThreshold = _data["attendeeHardThreshold"] !== undefined ? _data["attendeeHardThreshold"] : <any>null;
            this.employeeReserved = _data["employeeReserved"] !== undefined ? _data["employeeReserved"] : <any>null;
            this.booked = _data["booked"] !== undefined ? _data["booked"] : <any>null;
            this.timeSlotCategoryId = _data["timeSlotCategoryId"] !== undefined ? _data["timeSlotCategoryId"] : <any>null;
            this.timeSlotCategoryDescription = _data["timeSlotCategoryDescription"] !== undefined ? _data["timeSlotCategoryDescription"] : <any>null;
            this.forceTermsAcceptance = _data["forceTermsAcceptance"] !== undefined ? _data["forceTermsAcceptance"] : <any>null;
            this.openInvite = _data["openInvite"] !== undefined ? _data["openInvite"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): TimeSlotAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlotAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSlotValue"] = this.timeSlotValue ? this.timeSlotValue.toISOString() : <any>null;
        data["cutOffDate"] = this.cutOffDate ? this.cutOffDate.toISOString() : <any>null;
        data["attendeeSoftThreshold"] = this.attendeeSoftThreshold !== undefined ? this.attendeeSoftThreshold : <any>null;
        data["attendeeHardThreshold"] = this.attendeeHardThreshold !== undefined ? this.attendeeHardThreshold : <any>null;
        data["employeeReserved"] = this.employeeReserved !== undefined ? this.employeeReserved : <any>null;
        data["booked"] = this.booked !== undefined ? this.booked : <any>null;
        data["timeSlotCategoryId"] = this.timeSlotCategoryId !== undefined ? this.timeSlotCategoryId : <any>null;
        data["timeSlotCategoryDescription"] = this.timeSlotCategoryDescription !== undefined ? this.timeSlotCategoryDescription : <any>null;
        data["forceTermsAcceptance"] = this.forceTermsAcceptance !== undefined ? this.forceTermsAcceptance : <any>null;
        data["openInvite"] = this.openInvite !== undefined ? this.openInvite : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ITimeSlotAvailabilityDTO {
    timeSlotValue?: Date | null;
    cutOffDate?: Date | null;
    attendeeSoftThreshold?: number | null;
    attendeeHardThreshold?: number | null;
    employeeReserved?: boolean | null;
    booked?: number | null;
    timeSlotCategoryId?: number | null;
    timeSlotCategoryDescription?: string | null;
    forceTermsAcceptance?: boolean | null;
    openInvite?: boolean | null;
    id?: number | null;
}

export class WrappedResponseOfTimeSlotAvailabilityDTO implements IWrappedResponseOfTimeSlotAvailabilityDTO {
    metadata?: Metadata | null;
    data?: TimeSlotAvailabilityDTO | null;
    status?: WrappedResponseOfTimeSlotAvailabilityDTOStatus | null;

    constructor(data?: IWrappedResponseOfTimeSlotAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? TimeSlotAvailabilityDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfTimeSlotAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfTimeSlotAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfTimeSlotAvailabilityDTO {
    metadata?: Metadata | null;
    data?: TimeSlotAvailabilityDTO | null;
    status?: WrappedResponseOfTimeSlotAvailabilityDTOStatus | null;
}

export class WrappedResponseOfUserDTO implements IWrappedResponseOfUserDTO {
    metadata?: Metadata | null;
    data?: UserDTO | null;
    status?: WrappedResponseOfUserDTOStatus | null;

    constructor(data?: IWrappedResponseOfUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.data = _data["data"] ? UserDTO.fromJS(_data["data"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WrappedResponseOfUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedResponseOfUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWrappedResponseOfUserDTO {
    metadata?: Metadata | null;
    data?: UserDTO | null;
    status?: WrappedResponseOfUserDTOStatus | null;
}

export class UserDTO implements IUserDTO {
    id?: string | null;
    internalName?: string | null;
    name?: string | null;
    surname?: string | null;
    displayName?: string | null;
    cid?: string | null;
    isAuthorized?: boolean | null;
    email?: string | null;
    ticketsThreshold?: number | null;
    invitesThreshold?: number | null;
    roles?: string[] | null;
    canExceedTicketsThreshold?: boolean | null;
    canInviteVip?: boolean | null;
    thresholdByCategory?: boolean | null;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.internalName = _data["internalName"] !== undefined ? _data["internalName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.cid = _data["cid"] !== undefined ? _data["cid"] : <any>null;
            this.isAuthorized = _data["isAuthorized"] !== undefined ? _data["isAuthorized"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.ticketsThreshold = _data["ticketsThreshold"] !== undefined ? _data["ticketsThreshold"] : <any>null;
            this.invitesThreshold = _data["invitesThreshold"] !== undefined ? _data["invitesThreshold"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.canExceedTicketsThreshold = _data["canExceedTicketsThreshold"] !== undefined ? _data["canExceedTicketsThreshold"] : <any>null;
            this.canInviteVip = _data["canInviteVip"] !== undefined ? _data["canInviteVip"] : <any>null;
            this.thresholdByCategory = _data["thresholdByCategory"] !== undefined ? _data["thresholdByCategory"] : <any>null;
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["internalName"] = this.internalName !== undefined ? this.internalName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["cid"] = this.cid !== undefined ? this.cid : <any>null;
        data["isAuthorized"] = this.isAuthorized !== undefined ? this.isAuthorized : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["ticketsThreshold"] = this.ticketsThreshold !== undefined ? this.ticketsThreshold : <any>null;
        data["invitesThreshold"] = this.invitesThreshold !== undefined ? this.invitesThreshold : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["canExceedTicketsThreshold"] = this.canExceedTicketsThreshold !== undefined ? this.canExceedTicketsThreshold : <any>null;
        data["canInviteVip"] = this.canInviteVip !== undefined ? this.canInviteVip : <any>null;
        data["thresholdByCategory"] = this.thresholdByCategory !== undefined ? this.thresholdByCategory : <any>null;
        return data;
    }
}

export interface IUserDTO {
    id?: string | null;
    internalName?: string | null;
    name?: string | null;
    surname?: string | null;
    displayName?: string | null;
    cid?: string | null;
    isAuthorized?: boolean | null;
    email?: string | null;
    ticketsThreshold?: number | null;
    invitesThreshold?: number | null;
    roles?: string[] | null;
    canExceedTicketsThreshold?: boolean | null;
    canInviteVip?: boolean | null;
    thresholdByCategory?: boolean | null;
}

export enum WrappedResponseOfEventConfigurationDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum UiMessageType {
    SUCCESS = "SUCCESS",
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export enum UiMessageTarget {
    TOAST = "TOAST",
    VALIDATION = "VALIDATION",
    MODAL = "MODAL",
    CONSOLE = "CONSOLE",
}

export enum FilterComparator {
    Equal = "Equal",
    Greater = "Greater",
    Lower = "Lower",
    Contains = "Contains",
    In = "In",
}

export enum FilterConjunction {
    AND = "AND",
    OR = "OR",
}

export enum OrderByDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export enum WrappedResponseOfPagedListOfEventConfigurationDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfListOfTicketBookingDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum TicketBookingDTOStatus {
    CONFIRMED = "CONFIRMED",
    TEMPORARY = "TEMPORARY",
    BURNED = "BURNED",
    UNUSED = "UNUSED",
    CANCELED = "CANCELED",
}

export enum WrappedResponseOfTicketBookingDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfBooleanStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfTicketBookingExportDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfTicketBookingImportDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfPagedListOfTimeSlotAvailabilityDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfTimeSlotAvailabilityDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum WrappedResponseOfUserDTOStatus {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
